'use client';
import { ToggleGroup } from './toggle-group.js';
import { ToggleGroupItem } from './toggle-group-item.js';

/**
 * Display a group of buttons that can be toggled between.
 *
 * @example
 * <ToggleGroup data-toggle-group="Label" onChange={(value) => console.log(value)}>
 *   <ToggleGroup.Item value='1'>Toggle 1</ToggleGroup.Item>
 *   <ToggleGroup.Item value='2'>Toggle 2</ToggleGroup.Item>
 *   <ToggleGroup.Item value='3'>Toggle 3</ToggleGroup.Item>
 * </ToggleGroup>
 */
const ToggleGroupComponent = Object.assign(ToggleGroup, {
    Item: ToggleGroupItem,
});
ToggleGroupComponent.Item.displayName = 'ToggleGroup.Item';

export { ToggleGroupComponent as ToggleGroup, ToggleGroupItem };
